import { forwardRef } from "react"
import { StyledScannedPhoto, ReviewPhoto, Wrapper } from "./styled"

interface IScanedPhotoProps {
  imageUrl: string
}

const ImageScanningAnimation = forwardRef<HTMLDivElement, IScanedPhotoProps>(
  ({ imageUrl }, ref) => {
    return (
      <Wrapper>
        <StyledScannedPhoto ref={ref}>
          <ReviewPhoto src={imageUrl} />
          <div className="scan-to-bottom"></div>
          <div className="scan-to-top"></div>
        </StyledScannedPhoto>
      </Wrapper>
    )
  },
)

export default ImageScanningAnimation
